import { useMutation } from '@tanstack/react-query';
import { CompanyModel } from '../domain';
import { companiesRepo } from '@/constants/providers';

export const useUpdateCompany = () =>
  useMutation<CompanyModel, unknown, FormData>((data) =>
    companiesRepo.updateCompany(data),
  );
